import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Mail, Phone, MapPin } from 'lucide-react';

const ContactInfo = () => {
  const { t } = useLanguage();

  const contactItems = [
    { Icon: Mail, text: 'hello@mrkdigitalco.com', href: 'mailto:hello@mrkdigitalco.com', id: 'email' },
    { Icon: Phone, text: '+90 (507) 501 94 72', href: 'tel:+905075019472', id: 'phone' },
    { Icon: MapPin, text: 'İstanbul, Türkiye', id: 'location' }
  ];

  return (
    <div>
      <h3 className="text-white font-semibold mb-4">
        {t.language === 'tr' ? 'İletişim' : 'Contact'}
      </h3>
      <ul className="space-y-3 text-sm">
        {contactItems.map(({ Icon, text, id }) => (
          <li key={id} className="flex items-start space-x-3 text-gray-400">
            <Icon className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" />
            <span>{text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ContactInfo;
